import MarkdownIt from 'markdown-it';


export function MoMoAIHelperExtractTableData(tableElement) {
    const tableRows = Array.from(tableElement.querySelectorAll('tbody tr'));
    const tableData = tableRows.map(row => {
	const rowData = Array.from(row.querySelectorAll('td'));
		return rowData.map(cell => cell.textContent);
    });
    return tableData;
}
export function MoMOAIHelperConvertMarkdownToHTML(markdownContent) {
    // Create a new instance of MarkdownIt
    const md = new MarkdownIt();

    // Parse the Markdown content and generate an array of tokens
    const tokens = md.parse(markdownContent, {});
    // Render the tokens into HTML markup
    const html = md.renderer.render(tokens, md.options);
    return html;
}
export function MoMoAIHelperBreakdownMarkdown(markdownContent) {
    const md = new MarkdownIt();
    const tokens = md.parse(markdownContent, {});
    const container = document.createElement('div'); // Create a temporary container element

    let currentParent = container; // Track the current parent element

    tokens.forEach(token => {
        const element = document.createElement(token.tag || 'div'); // Create an element based on the token's tag or use a div as fallback
        element.innerHTML = token.content || ''; // Set the element's innerHTML to the token's content

        if (token.attrs) {
            token.attrs.forEach(([name, value]) => {
                element.setAttribute(name, value); // Set attributes of the element based on token's attrs
            });
        }

        if (token.nesting === 1) {
            // Opening tag token
            currentParent.appendChild(element); // Append the element to the current parent
            currentParent = element; // Update the current parent to be the newly created element
        } else if (token.nesting === -1) {
            // Closing tag token
            currentParent = currentParent.parentNode; // Move back to the parent of the current parent
        } else {
            // Self-closing tag token or other cases
            currentParent.appendChild(element); // Append the element to the current parent
        }
        // Add the key and innerHTML association
        if (token.tag) {
            container[token.tag] = container[token.tag] || [];
            container[token.tag].push({
                key: token.tag,
                innerHTML: element.innerHTML
            });
        }
    });
    return Array.from(container.childNodes);
}
